<template>
  <div v-show="isSketchList" id="plan_table">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- 担当者情報モーダル -->
    <dd-plan-person-modal
      ref="planPersonModalRef"
      :isSketchList="isSketchList"
      @onClickPerson="onClickPerson"
    />
    <!-- ステータス変更モーダル -->
    <dd-plan-proposed-status-modal
      ref="planProposedStatusModalRef"
      :isSketchList="isSketchList"
      @onClickStatus="onClickStatus"
      @statusChanged="handleStatusChange"
    />
    <!-- 割り当て変更モーダル -->
    <dd-kagler-select-modal
      ref="kaglerSelectModalRef"
      @onClickKaglerSelect="onClickKaglerSelect"
      @kaglerChange="handleKaglerChange"
    />
    <!-- 提案変更モーダル -->
    <dd-plan-propose-product-modal
      ref="planProposeProductModalRef"
      @onClickProposeProduct="onClickProposeProduct"
      @updateSketchList="updateSketchList"
    />
    <!-- アップロード画像一覧表示モーダル -->
    <dd-plan-uplode-img-modal
      ref="planUploadeImgModalRef"
      @onClickUploadeImgList="onClickUploadeImgList"
    />
    <!-- コメント表示モーダル -->
    <dd-plan-comment-modal
      ref="planCommentModalRef"
      @onClickComment="onClickComment"
    />
    <div class="table_wrapper">
      <!--  タイトルエリア  -->
      <div class="title_area" id="title_area_sketch">
        <h3 v-if="isSketchList">スケッチオーダー管理</h3>
      </div>
      <div class="form_area">
        <!-- ページ -->
        <div>
          <dd-pager
            ref="pagerRef"
            :pageNo="pageNo"
            :dataCountPerPage="dataCount"
            :totalDataCount="totalCount"
            @paging="paging"
          />
        </div>
      </div>
      <!-- データテーブル -->
      <div class="plan_list_area">
        <table>
          <thead>
            <tr>
              <th class="check_area" :class="{none: checkDisp(0)}">スケッチID</th>
              <th class="check_area" :class="{none: checkDisp(1)}">顧客氏名</th>
              <th class="check_area" :class="{none: checkDisp(2)}">ステータス</th>
              <th class="check_area" :class="{none: checkDisp(3)}">確度</th>
              <th class="check_area" :class="{none: checkDisp(4)}">収益分配設定</th>
              <th class="check_area" :class="{none: checkDisp(5)}">担当プランナー</th>
              <th class="check_area" :class="{none: checkDisp(6)}">アップロードファイル</th>
              <th class="check_area" :class="{none: checkDisp(7)}">納品希望関連</th>
              <th class="check_area" :class="{none: checkDisp(8)}">予算希望関連</th>
              <th class="check_area" :class="{none: checkDisp(9)}">納品日</th>
              <th class="check_area" :class="{none: checkDisp(10)}">事前現場調査日</th>
              <th class="check_area" :class="{none: checkDisp(11)}">施工日</th>
              <th class="check_area" :class="{none: checkDisp(12)}">顧客連絡先メールアドレス</th>
              <th class="check_area" :class="{none: checkDisp(13)}">顧客電話番号</th>
              <th class="check_area" :class="{none: checkDisp(14)}">顧客郵便番号</th>
              <th class="check_area" :class="{none: checkDisp(15)}">顧客住所</th>
              <th class="check_area" :class="{none: checkDisp(16)}">設置場所について</th>
              <th class="check_area" :class="{none: checkDisp(17)}">エレベータの有無</th>
              <th class="check_area" :class="{none: checkDisp(18)}">コメント</th>
              <th class="check_area" :class="{none: checkDisp(19)}">提案中プラン</th>
              <th class="check_area" :class="{none: checkDisp(20)}">過去の提案</th>
              <th class="check_area" :class="{none: checkDisp(21)}">事前現場調査</th>
              <th class="check_area" :class="{none: checkDisp(22)}">受注</th>
              <th class="check_area" :class="{none: checkDisp(23)}">確定納品日</th>
              <th class="check_area" :class="{none: checkDisp(24)}">確定施工日</th>
              <th class="check_area" :class="{none: checkDisp(25)}">納品完了</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(plan, index) in dispPlanDataList" :key="index"
              @mouseover="mouseOverLine(plan.sketchId)"
              @mouseleave="mouseLeaveList()"
              :class="{selectLine: mouseOverSketch===plan.sketchId}"
            >
              <td class="check_area" :class="{none: checkDisp(0)}">{{ plan.sketchId }}</td>
              <td class="check_area" :class="{none: checkDisp(1)}">{{ plan.userLastName}}{{plan.userFirstName}}</td>
              <td class="check_area" :class="{none: checkDisp(2)}"></td>
              <td class="check_area" :class="{none: checkDisp(3)}"></td>
              <td class="check_area" :class="{none: checkDisp(4)}"></td>
              <td class="check_area" :class="{none: checkDisp(5)}"></td>
              <td class="check_area" :class="{none: checkDisp(6)}">
                <div class="skecth_list">
                  <img v-for="(img, index) in plan.sketchUploadModelList" :key="index" :src="getImage(changeImagePath(img.sketchUploadImg))">
                </div>
              </td>
              <td class="check_area" :class="{none: checkDisp(7)}"></td>
              <td class="check_area" :class="{none: checkDisp(8)}"></td>
              <!-- <td class="check_area"><button class="list_btn gray_btn" @click="onClickUploadeImgList(plan.sketchId)"></button></td> -->
              <!-- <td class="check_area" :class="{none: checkDisp(1)}">{{ getFormatDate(plan.sketchUploadDate) }}</td>
              <td class="check_area" :class="{none: checkDisp(2)}">
                <a v-if="plan.sketchPersonUserId" id="person_btn" @click="onClickPerson(plan)">{{ makeFullName(plan.userModel.userLastName, plan.userModel.userFirstName) }}</a>
                <span v-else>未割当</span>
                <button class="disp_btn" @click="onClickKaglerSelect(plan.sketchManagerId, index)" v-if="userInfo.userType=='SYSTEM_ADMIN'">割り当て</button>
              </td>
              <td class="check_area" :class="{none: checkDisp(3)}" v-show="false">{{ convertStatusCode(plan.sketchProposeStatus) }}
                <button class="main_btn" @click="onClickStatus(plan.sketchProposeStatus, index)">ステータス変更</button>
              </td> -->
              <!-- <td class="check_area" :class="{none: checkDisp(4)}" v-show="false">{{ getFormatDate(plan.proposeProductModel.proposeDate) }}</td> -->
              <!-- <td class="check_area" v-show="false"><button class="list_btn" @click="onClickProposeProduct(plan.sketchId, index)">提案</button></td> -->
              <!-- <td class="check_area" :class="{none: checkDisp(5)}" v-show="false">{{ plan.sketchProposeCount }}</td> -->
              <!-- <td class="check_area" :class="{none: checkDisp(6)}" v-show="false">{{ plan.sketchUploadDate }}<button class="main_btn">納品日選択</button></td> -->
              <td class="check_area" :class="{none: checkDisp(7)}" v-show="false">{{ plan.sketchUploadDate }}<button class="main_btn">施工日選択</button></td>
              <td class="check_area" :class="{none: checkDisp(8)}" v-show="false">{{ plan.sketchUploadDate }}<button class="main_btn">確定</button></td>
              <td class="check_area" :class="{none: checkDisp(9)}">{{ plan.corpEmail }}</td>
              <td class="check_area" :class="{none: checkDisp(10)}">{{ plan.userLastName}}{{plan.userFirstName}}</td>
              <td class="check_area" :class="{none: checkDisp(11)}">{{ plan.corpTel }}</td>
              <td class="check_area" :class="{none: checkDisp(12)}">{{ plan.sketchUserPostcd }}</td>
              <td class="check_area" :class="{none: checkDisp(13)}">{{ plan.sketchUserAddress}}{{plan.sketchUserStreetBuilding}}</td>
              <td class="check_area" :class="{none: checkDisp(14)}">{{ convertInstLocation(plan.sketchManagerInstLocation) }}</td>
              <td class="check_area" :class="{none: checkDisp(15)}">{{ convertElevatorFlg(plan.sketchManagerElevatorFlg) }}</td>
              <td class="check_area" :class="{none: checkDisp(16)}"><a id="comment_btn" @click="onClickComment(plan.sketchComment)">コメントを表示</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {API_URL, STORAGE_KEY} from '../../constants/App'
// import {LIST_TYPE, SERVICE_TYPE, PLAN_STATUS} from '../../constants/Type'
import {PLAN_STATUS} from '../../constants/Type'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import PlanSearchModal from '../list/modal/PlanSearchModal'
import LoadingModal from '../common/LoadingModal'
import Pager from '../../components/common/OrderPager'
import SketchPersonModal from './modal/SketchPersonModal'
import SketchProposedStatus from './modal/SketchProposedStatus'
import SketchKaglerSelectModal from './modal/SketchKaglerSelect'
import SketchProposeProductModal from './modal/SketchProposeProduct'
import SketchUplodeImgListModal from './modal/SketchUplodeImgList'
import SketchCommentModal from './modal/SketchComment'

export default {
  name: 'SketchOrderManagementTable',
  components: {
    'dd-plan-search-modal': PlanSearchModal,
    'dd-pager': Pager,
    'dd-plan-person-modal': SketchPersonModal,
    'dd-plan-proposed-status-modal': SketchProposedStatus,
    'dd-loading-modal': LoadingModal,
    'dd-kagler-select-modal': SketchKaglerSelectModal,
    'dd-plan-propose-product-modal': SketchProposeProductModal,
    'dd-plan-uplode-img-modal': SketchUplodeImgListModal,
    'dd-plan-comment-modal': SketchCommentModal
  },
  props: {
    isSketchList: Boolean,
    customNameList: Array,
    dispForm: Object
  },
  data () {
    return {
      /** ページ番号 */
      pageNo: 1,
      /** 1ページごとの表示件数 */
      dataCount: 14,
      /** 総件数 */
      // totalCount: 0,
      /** 総件数(テスト用で100に設定) */
      totalCount: 100,
      /** 表示用プランリスト */
      dispPlanDataList: [],
      /** 処理日 */
      processingDate: '',
      /** 検索条件 */
      searchForm: {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        orderDateStart: '',
        orderDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        businessName: '',
        fileName: '',
        pageNo: '',
        dataCount: ''
      },
      mouseOverSketch: undefined,
      defaultDispStatus: [PLAN_STATUS.SKETCH_ORDER.code]
    }
  },
  computed: {
    userInfo: function () {
      return App.getUserInfo()
    }
  },
  watch: {
    /** スケッチオーダーリスト表示フラグ */
    isSketchList: function () {
      if (this.isSketchList) {
        document.addEventListener('mouseup', this.onMouseup)
      } else {
        document.removeEventListener('mouseup', this.onMouseup)
      }
    }
  },
  methods: {
    getImage: function (image) {
      return App.getContentsSkupResource(image)
    },
    /** スケッチオーダー管理リストを取得・表示 */
    getSketchList: function (isFirstView) {
      if (isFirstView) {
        this.pageNo = 1
        this.$refs.pagerRef.setCurrentPage(this.pageNo)
        this.clear()
      } else {
        this.searchForm = App.getLocalStorage(STORAGE_KEY.PLAN_SEARCH)
      }
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount

      // スケッチオーダー管理リストを取得
      axios.post(API_URL.LIST + '/sketch-order')
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.planDataList = response.data.data
          this.dispPlanDataList = this.planDataList
          console.dir(this.dispPlanDataList)
          this.totalCount = response.data.data.totalCount
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    changeImagePath: function (imgPath) {
      const contentsPath = 'contents/skup/'
      let cnt = imgPath.indexOf(contentsPath)
      let ret = imgPath.substr(cnt)
      return ret.replace(contentsPath, '')
    },
    /** 項目の表示・非表示判定 */
    checkDisp: function (num) {
      return !this.dispForm.sketchCheckList.includes(num)
    },
    /** 数字ボタンが押すたびに動く処理 */
    paging: function (pageNo) {
      this.pageNo = pageNo
      this.searchForm = App.getLocalStorage(STORAGE_KEY.PLAN_SEARCH)
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
    },
    clear: function () {
      this.searchForm = {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        orderDateStart: '',
        orderDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        businessName: '',
        fileName: '',
        pageNo: '',
        dataCount: ''
      }
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD hh:mm')
      } else {
        return ''
      }
    },
    getFormatSimpleDate: function (date) {
      if (date) {
        return moment(date).format('M/DD')
      } else {
        return ''
      }
    },
    /** フルネーム作成 */
    makeFullName: function (lastName, firstName) {
      return lastName + firstName
    },
    /** 住所作成 */
    makeFullAddress: function (address, street) {
      return address + street
    },
    /** 提案ステータスをコードから変換 */
    convertStatusCode: function (proposeStatus) {
      switch (proposeStatus) {
        case 0:
          return '未提案'
        case 1:
          return '担当割り当て済み'
        case 2:
          return '提案中'
        case 3:
          return '差し戻し'
        case 4:
          return '確定'
        default:
          console.log('想定外のコードです')
          return ''
      }
    },
    /** 設置場所をコードから変換 */
    convertInstLocation: function (instLocation) {
      switch (instLocation) {
        case 1:
          return '集合住宅(1階)'
        case 2:
          return '集合住宅(2階以上)'
        case 3:
          return '一戸建て住宅(1階)'
        case 4:
          return '一戸建て住宅(2階以上)'
        case 5:
          return 'その他'
        default:
          console.log('想定外のコードです')
          return ''
      }
    },
    /** エレベーターの有無を変換 */
    convertElevatorFlg: function (elevatorFlg) {
      if (elevatorFlg) {
        return '有り'
      } else {
        return '無し'
      }
    },
    /** 担当者情報モーダルを開く */
    onClickPerson: function (plan) {
      this.$refs.planPersonModalRef.showModal(plan)
    },
    /** ステータス変更モーダルを開く */
    onClickStatus: function (currentStatus, index) {
      this.$refs.planProposedStatusModalRef.showModal(currentStatus, index)
    },
    /** 割り当て変更モーダルを開く */
    onClickKaglerSelect: function (currentStatus, index) {
      this.$refs.kaglerSelectModalRef.showModal(currentStatus, index)
    },
    /** 提案変更モーダルを開く */
    onClickProposeProduct: function (sketchId, index) {
      this.$refs.planProposeProductModalRef.showModal(sketchId, index)
    },
    onClickUploadeImgList: function (sketchId) {
      this.$refs.planUploadeImgModalRef.showModal(sketchId)
    },
    onClickComment: function (comment) {
      this.$refs.planCommentModalRef.showModal(comment)
    },
    /** ダイアログ内でのステータス変更を反映 */
    handleStatusChange: function (data) {
      let selectedProposedStatus = data.status
      let index = data.index
      this.$set(this.dispPlanDataList, index, {...this.dispPlanDataList[index], sketchProposeStatus: selectedProposedStatus})
      console.log(JSON.stringify(this.dispPlanDataList))
    },
    /** kaglerの変更を反映 */
    handleKaglerChange: function (data) {
      this.dispPlanDataList = data.data.data
    },
    /** スケッチオーダーリストを再表示 */
    updateSketchList: function () {
      this.getSketchList(false)
    },
    mouseOverLine: function (sketchId) {
      this.mouseOverSketch = sketchId
      console.log('mouseover sketch id' + this.mouseOverSketch)
    },
    mouseLeaveList: function () {
      this.mouseOverSketch = undefined
      console.log('mouseleave')
    }
  },
  mounted: function () {
    this.processingDate = this.getFormatDate(new Date())
  },
  beforeDestroy: function () {
    document.removeEventListener('mouseup', this.onMouseup)
  }
}
</script>

<style src="../../css/list/list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#person_btn, #comment_btn {
  color: #0000EE;
}
#person_btn:hover, #comment_btn:hover {
  color: #ff4500;
}
.selectLine {
  td {
    background: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/SketchOrderManagementTable.vue